// extracted by mini-css-extract-plugin
export var scrollArea = "_ov-0";